import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faCircle, faPlusCircle, faSortDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import {
    ASK_AN_EXPERT,
    BAZAAR,
    BLOGS_MENU_FEEDS,
    BLOGS_WALL,
    BZ2_ADD_PRODUCT,
    BZ2_FAQ,
    BZ2_WISHLIST,
    CONTESTS,
    FORUMS_AND_GROUPS,
    HEADING_SELLERS,
    LOG_IN,
    MORE_WIKI_CATEGORIES,
    MY_ENTRIES,
    MY_SHOPPING,
    PB_MENU_FIND_MOM,
    PB_MENU_MY_ACTIVITY,
    REGISTER_HERE,
    SERVER_FULL_NAME,
    SERVER_SLOGAN,
    STROLLER_STROLLEROPEDIA,
    TESTINGS,
    YOUTUBE_MK_TITLE,
} from 'mk/autogenerated/translations/DesktopHeader.2dedc027372164883db2b400851719f7'
import { WIKI_CATEGORIES } from 'mk/autogenerated/wikiCategories';
import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import assetUrl from 'mk/common/assetUrl';
import {
    bazaar_single_page_create_product_url,
    bazaar_single_page_my_bazaar_url,
    bazaar_single_page_product_grid_url,
    bazaar_single_page_seller_search_url,
    bazaar_single_page_shopping_url,
    bazaar_single_page_wishlist_url,
} from 'mk/urls/functions';
import { blogsFeedWithCategoryUrl, blogsUrl } from 'mk2/apps/blogs/urls';
import { contestsHomeUrl } from 'mk2/apps/contests/urls';
import { counsellingsHomeUrl } from 'mk2/apps/counsellings/urls';
import { faqIndexUrl } from 'mk2/apps/faq/urls';
import CovidPanel, { DISPLAY_COVID_PANEL } from 'mk2/apps/forum/components/CovidPanel';
import { forumUrl } from 'mk2/apps/forum/urls';
import { homepageUrl } from 'mk2/apps/home/urls';
import { strollersUrl } from 'mk2/apps/strollers/urls';
import { testingsHomeUrl } from 'mk2/apps/testings/urls';
import { loginUrl, signupUrl, usersDirectoryUrl } from 'mk2/apps/users/urls';
import { isStrollers } from 'mk2/apps/wiki/helpers';
import { wikiCategoryUrl } from 'mk2/apps/wiki/utils';
import Img from 'mk2/components/Img';
import Interpolate from 'mk2/components/Interpolate';
import Link from 'mk2/components/Link';
import NotificationsBadge, { Count, Type } from 'mk2/components/NotificationsBadge';
import NotificationMenu from 'mk2/components/NotificationMenu';
import { MenuItem } from 'mk2/containers/PageHeader/PageHeader.reducers';
import styles from 'mk2/containers/SiteMenu/DesktopHeader.mscss';
import { modrykonikLogoUrl, url } from 'mk2/helpers/urls';
import { HeaderMenuItem, MenuSelection, SubscribedCounsellingsCounts, UserEntity } from 'mk2/schemas';
import React from 'react';

interface OwnProps {
    menuSelection?: MenuSelection;
    currentUrl: string;  // nemozeme pouzit withRouter(), ten nefunguje v bazari

    requestUser: UserEntity;
    requestUserPermissions: string[];
    isMobile: boolean;
    heartsCount: number;
    unreadMails: number;
    newBazaarEvents: number;
    newBazaarSell: number;
    allBazaarSell: number;
    wallStatusNews: number;
    wishlistUpdates: number;
    newContests: number;
    subscribedCounsellings: SubscribedCounsellingsCounts;
    newTestingCalls: number;
    feedMenu: MenuItem[];
    subMenuDropdownOpened: boolean;

    notificationMenuRef: React.RefObject<NotificationMenu>;
    onMenuClose();
    onStoreEvent(name: string, props: any);
    onSubMenuDropdownChange(opened: boolean);
}

interface SectionTabItem {
    section: string;
    content: React.ReactNode;
}

interface SubMenuItem {
    menuItem: string;
    className?: string;
    content: React.ReactNode;
    groupped?: boolean;
}

type Props = OwnProps;

export class DesktopHeader extends React.PureComponent<Props> {

    private subMenuDropdownRef = null;

    public componentDidMount() {
        window.addEventListener('click', this.onClickOutside);
    }

    public componentWillUnmount() {
        window.removeEventListener('click', this.onClickOutside);
    }

    public render() {
        const { menuSelection } = this.props;

        let activeSection;
        let activeItem;
        if (menuSelection && menuSelection.activeSection) {
            activeSection = menuSelection.activeSection;
            if (activeSection === 'forum' || activeSection === 'groups') {
                activeSection = 'forum_and_groups';
            }
        }
        if (menuSelection && menuSelection.activeItem) {
            activeItem = menuSelection.activeItem;
        }

        return (
            <div className={styles.DesktopHeader}>
                <div className={styles.DesktopHeader__mainWrapper}>
                    <div className={styles.DesktopHeader__main}>
                        <div className={styles.DesktopHeader__firstLineWrapper}>
                            {/* Hearts, IP, Wall, Settings */}
                            {this.renderHeartsWallSettingsStripe(activeSection, activeItem)}
                            {DISPLAY_COVID_PANEL && (
                                <div className={styles.DesktopHeader__covidWrapper}>
                                    <CovidPanel isMobile={false} />
                                </div>
                            )}
                        </div>
                        <div className={styles.DesktopHeader__secondLineWrapper}>
                            {this.renderLogo(activeSection, activeItem)}

                            {/* Bazar, Forum, Stena, Poradne */}
                            {this.renderSectionTabs(activeSection, activeItem)}
                        </div>
                    </div>
                </div>

                {['photoblog', 'bazaar', 'home', 'wiki'].indexOf(activeSection) >= 0 && (
                    <div className={styles.DesktopHeader__subMenuWrapper}>
                        {activeSection === 'photoblog'
                            ? this.renderBlogsSubMenu(activeItem)
                            : activeSection === 'bazaar'
                                ? this.renderMarketSubMenu(activeItem)
                                : (activeSection === 'home' || activeSection === 'wiki')
                                    ? this.renderHomeSubMenu(activeItem)
                                    : null
                        }
                    </div>
                )}
            </div>
        );
    }

    private renderLogo(activeSection: string, activeItem: string) {
        const { onMenuClose } = this.props;

        const logo = (
            <Img
                lazy={false}
                height={34}
                width={150}
                alt={SERVER_FULL_NAME + ' - ' + SERVER_SLOGAN}
                src={modrykonikLogoUrl()}
            />
        );

        return (
            <div
                onClick={onMenuClose}
                className={cx(
                    styles.DesktopHeader__logo,
                    (activeSection === 'home' || activeSection === 'wiki') && styles['DesktopHeader__tabItem--active'],
                )}
            >
                <Link
                    title={SERVER_FULL_NAME + ' - ' + SERVER_SLOGAN}
                    to={homepageUrl}
                >
                    {logo}
                </Link>
            </div>
        );
    }

    private renderSectionTabs(activeSection: string, activeItem: string) {
        const {
            newBazaarEvents, newBazaarSell, newContests, newTestingCalls,
            subscribedCounsellings, onMenuClose,
        } = this.props;

        const totalSubscribedCounsellings = Object.keys(subscribedCounsellings || {}).reduce((acc, cur) => acc + subscribedCounsellings[cur], 0);

        const items: SectionTabItem[] = [
            {
                section: 'bazaar',
                content: (
                    <Link
                        className={styles.DesktopHeader__tabItemLink}
                        to={bazaar_single_page_product_grid_url()}
                    >
                        {BAZAAR}
                        <NotificationsBadge
                            className={styles.DesktopHeader__tabItemNotificationsBadge}
                            count={newBazaarEvents + newBazaarSell}
                            type={Type.Important}
                        />
                    </Link>
                ),
            }, {
                section: 'forum_and_groups',
                content: (
                    <Link
                        className={styles.DesktopHeader__tabItemLink}
                        to={forumUrl}
                    >
                        {FORUMS_AND_GROUPS}
                    </Link>
                ),
            }, {
                section: 'photoblog',
                content: (
                    <Link
                        className={styles.DesktopHeader__tabItemLink}
                        to={blogsUrl}
                    >
                        {BLOGS_WALL}
                    </Link>
                ),
            }, {
                section: 'counsellings',
                content: (
                    <Link
                        className={styles.DesktopHeader__tabItemLink}
                        to={counsellingsHomeUrl}
                    >
                        {ASK_AN_EXPERT}
                        <NotificationsBadge
                            className={styles.DesktopHeader__tabItemNotificationsBadge}
                            count={totalSubscribedCounsellings}
                        />
                    </Link>
                ),
            }, {
                section: 'contests',
                content: (
                    <Link
                        className={styles.DesktopHeader__tabItemLink}
                        to={contestsHomeUrl}
                    >
                        {CONTESTS}
                        <NotificationsBadge
                            className={styles.DesktopHeader__tabItemNotificationsBadge}
                            count={newContests}
                        />
                    </Link>
                ),
            }, {
                section: 'testings',
                content: (
                    <Link
                        className={styles.DesktopHeader__tabItemLink}
                        to={testingsHomeUrl}
                    >
                        {TESTINGS}
                        <NotificationsBadge
                            className={styles.DesktopHeader__tabItemNotificationsBadge}
                            count={newTestingCalls}
                        />
                    </Link>
                ),
            },
        ];

        return (
            <ul className={styles.DesktopHeader__tabs}>
                {items.map((item) => (
                    <li
                        key={item.section}
                        onClick={onMenuClose}
                        className={cx(
                            styles.DesktopHeader__tabItem,
                            activeSection === item.section && styles['DesktopHeader__tabItem--active'],
                        )}
                    >
                        {item.content}
                    </li>
                ))}
            </ul>
        );
    }

    private renderHomeSubMenu(activeItem: string) {
        const items: SubMenuItem[] = WIKI_CATEGORIES
            .filter((wikiCategory) => wikiCategory.id !== 11 && wikiCategory.id !== 12 && !isStrollers(wikiCategory.slug))
            .map((wikiCategory, i) => ({
                menuItem: wikiCategory.slug,
                content: (
                    <Link
                        className={cx(
                            styles.DesktopHeader__subMenuItemLink,
                            i === 0 && styles['DesktopHeader__subMenuItemLink--first'],
                        )}
                        to={wikiCategoryUrl(wikiCategory)}
                    >
                        {wikiCategory.name}
                    </Link>
                ),
                groupped: ![1, 2, 5].includes(wikiCategory.id),
            }));

        const trailingItems = [{
            menuItem: 'youtube',
            className: styles['DesktopHeader__subMenuItem--right'],
            content: (
                <Link
                    className={styles.DesktopHeader__subMenuItemLink}
                    to="https://www.youtube.com/Modrykonik"
                >
                    <FontAwesomeIcon
                        icon={faYoutube}
                        className={styles.DesktopHeader__subMenuItemLink__icon}
                    />
                    {YOUTUBE_MK_TITLE}
                </Link>
            ),
        }, {
            menuItem: 'strollersbase',
            content: (
                <Link
                    className={cx(
                        styles.DesktopHeader__subMenuItemLink,
                        styles['DesktopHeader__subMenuItemLink--last'],
                    )}
                    to={strollersUrl}
                >
                    <Img
                        width={18}
                        height={18}
                        alt={SERVER_FULL_NAME + ' - ' + SERVER_SLOGAN}
                        src={assetUrl + 'img/logos/ver-4/stroller@2x.png'}
                        lazy={false}
                        className={styles.DesktopHeader__subMenuItemLink__logo}
                    />
                    {STROLLER_STROLLEROPEDIA}
                </Link>
            ),
        }];

        return this.renderGenericSubMenu(items, trailingItems, activeItem);
    }

    private renderBlogsSubMenu(activeItem: string) {
        const { feedMenu, requestUser, requestUserPermissions } = this.props;

        const isBlogsAdmin = requestUserPermissions.indexOf('photoblog.can_manage_blogs') >= 0;
        const feedsCount = feedMenu !== null && feedMenu.length > 0 && feedMenu.filter((item) => item.name === 'feeds').reduce((acc: Count, val) => val.lastVisitCount, null);

        const items: SubMenuItem[] = isAuthenticated(requestUser)
            ? [
                {
                    menuItem: 'feeds',
                    content: (
                        <Link
                            className={styles.DesktopHeader__subMenuItemLink}
                            to={blogsUrl}
                        >
                            {BLOGS_MENU_FEEDS}&nbsp;{feedsCount ? (<i>{feedsCount}</i>) : null}
                        </Link>
                    ),
                }, {
                    menuItem: 'my-activity-feed',
                    content: (
                        <Link
                            className={styles.DesktopHeader__subMenuItemLink}
                            to={url(blogsFeedWithCategoryUrl, {category: 'my-activity'})}
                        >
                            {PB_MENU_MY_ACTIVITY}
                        </Link>
                    ),
                }, {
                    menuItem: 'user-directory',
                    content: (
                        <Link
                            className={styles.DesktopHeader__subMenuItemLink}
                            to={usersDirectoryUrl}
                        >
                            {PB_MENU_FIND_MOM}
                        </Link>
                    ),
                },
            ] : [];

        if (isBlogsAdmin) {
            const flaggedCount = feedMenu !== null && feedMenu.length > 0 && feedMenu.filter((item) => item.name === 'flagged').reduce((acc: Count, val) => val.lastVisitCount, null);
            items.push({
                menuItem: 'flagged',
                content: (
                    <Link
                        className={styles.DesktopHeader__subMenuItemLink}
                        to={url(blogsFeedWithCategoryUrl, {category: 'flagged'})}
                    >
                        Flagged&nbsp;{flaggedCount ? (<i>{flaggedCount}</i>) : null}
                    </Link>
                ),
            });
        }

        return this.renderGenericSubMenu(items, [], activeItem);
    }

    private renderMarketSubMenu(activeItem: string) {
        const { requestUser, newBazaarSell, allBazaarSell, wishlistUpdates, newBazaarEvents } = this.props;

        let items: SubMenuItem[] = isAuthenticated(requestUser)
            ? [
                {
                    menuItem: HeaderMenuItem.BazaarMyBazaar,
                    content: (
                        <Link
                            className={cx(
                                styles.DesktopHeader__subMenuItemLink,
                                styles['DesktopHeader__subMenuItemLink--first'],
                            )}
                            to={bazaar_single_page_my_bazaar_url(requestUser.username)}
                        >
                            {MY_ENTRIES}
                            {newBazaarSell > 0 ? (
                                <NotificationsBadge className={styles.DesktopHeader__tabItemNotificationsBadge} count={newBazaarSell} type={Type.Important} />
                            ) : allBazaarSell > 0 ? (
                                <i>{allBazaarSell}</i>
                            ) : null}
                        </Link>
                    ),
                }, {
                    menuItem: HeaderMenuItem.BazaarWishlist,
                    content: (
                        <Link
                            className={styles.DesktopHeader__subMenuItemLink}
                            to={bazaar_single_page_wishlist_url(requestUser.username)}
                        >
                            {BZ2_WISHLIST}
                            {wishlistUpdates > 0 && (<i>{wishlistUpdates}</i>)}
                        </Link>
                    ),
                }, {
                    menuItem: HeaderMenuItem.BazaarShopping,
                    content: (
                        <Link
                            className={styles.DesktopHeader__subMenuItemLink}
                            to={bazaar_single_page_shopping_url(requestUser.username)}
                        >
                            {MY_SHOPPING}
                            <NotificationsBadge
                                className={styles.DesktopHeader__tabItemNotificationsBadge}
                                count={newBazaarEvents}
                                type={Type.Important}
                            />
                        </Link>
                    ),
                }, {
                    menuItem: HeaderMenuItem.BazaarSellerSearch,
                    content: (
                        <Link
                            className={styles.DesktopHeader__subMenuItemLink}
                            to={bazaar_single_page_seller_search_url()}
                        >
                            {HEADING_SELLERS}
                        </Link>
                    ),
                },
            ] : [];

        // Always add FAQ and Add Product links
        items = items.concat([
            {
                menuItem: HeaderMenuItem.BazaarFaq,
                content: (
                    <Link
                        className={styles.DesktopHeader__subMenuItemLink}
                        to={url(faqIndexUrl, { articleSlug: 'faq-index-bazar' })}
                    >
                        {BZ2_FAQ}
                    </Link>
                ),
            }, {
                menuItem: HeaderMenuItem.BazaarAddItem,
                className: styles['DesktopHeader__subMenuItem--right'],
                content: (
                    <Link
                        className={cx(
                            styles.DesktopHeader__subMenuItemLink,
                            styles['DesktopHeader__subMenuItemLink--add'],
                        )}
                        to={bazaar_single_page_create_product_url()}
                    >
                            <span className={cx('fa-layers fa-fw', styles.DesktopHeader__subMenuItemLinkAddIcon)}>
                                <FontAwesomeIcon icon={faCircle} className={styles.DesktopHeader__subMenuItemLinkAddIcon__background} />
                                <FontAwesomeIcon icon={faPlusCircle} className={styles.DesktopHeader__subMenuItemLinkAddIcon__icon} transform="shrink-3" />
                            </span>{' '}
                        {BZ2_ADD_PRODUCT}
                    </Link>
                ),
            },
        ]);

        return this.renderGenericSubMenu(items, [], activeItem);
    }

    private renderGenericSubMenu(groupableItems: SubMenuItem[], trailingItems: SubMenuItem[], activeItem: string) {
        const isGrouppedItems = groupableItems.filter((item: SubMenuItem) => item.groupped).length > 0;
        return (
            <ul className={styles.DesktopHeader__subMenu}>
                {groupableItems.map((item: SubMenuItem) => {
                    return (!item.groupped) ? (
                        <li
                            key={item.menuItem}
                            className={cx(
                                styles.DesktopHeader__subMenuItem,
                                item.className,
                                activeItem === item.menuItem && styles['DesktopHeader__subMenuItem--active'],
                                activeItem === item.menuItem && 'topmenu-activeLink',
                            )}
                        >
                            {item.content}
                        </li>
                    ) : null;
                })}
                {isGrouppedItems && (
                    <li
                        key={'sub-menu-groupped-others-closed'}
                        className={cx(
                            styles.DesktopHeader__subMenuItem,
                        )}
                    >
                        <a
                            className={cx(
                                styles.DesktopHeader__subMenuItemLink,
                                styles['DesktopHeader__subMenuItemLink--subMenudropdown'],
                            )}
                            onClick={this.handleToggleSubMenuDropdown}
                        >
                            {MORE_WIKI_CATEGORIES} <FontAwesomeIcon icon={faSortDown} className={styles.DesktopHeader__subMenuItem__group__fa}/>
                        </a>
                        {this.props.subMenuDropdownOpened && (
                            <div
                                className={styles.DesktopHeader__subMenuItem__groupWrapper}
                                ref={this.setSubMenuDropdownRef}
                            >
                                <ul className={styles.DesktopHeader__subMenuItem__group}>
                                    <li
                                        key={'sub-menu-groupped-others-opened'}
                                        className={cx(
                                            styles.DesktopHeader__subMenuItem,
                                            styles['DesktopHeader__subMenuItem--active'],
                                        )}
                                    >
                                        <a
                                            className={cx(
                                                styles.DesktopHeader__subMenuItemLink,
                                                styles['DesktopHeader__subMenuItemLink--subMenudropdown'],
                                            )}
                                        >
                                            {MORE_WIKI_CATEGORIES} <FontAwesomeIcon icon={faSortDown} className={styles.DesktopHeader__subMenuItem__group__fa}/>
                                        </a>
                                    </li>
                                    {groupableItems.map((item: SubMenuItem) => {
                                        return (item.groupped) ? (
                                            <li
                                                key={item.menuItem}
                                                className={cx(
                                                    styles.DesktopHeader__subMenuItem,
                                                    item.className,
                                                    activeItem === item.menuItem && styles['DesktopHeader__subMenuItem--active'],
                                                    activeItem === item.menuItem && 'topmenu-activeLink',
                                                )}
                                            >
                                                {item.content}
                                            </li>
                                        ) : null;
                                    })}
                                </ul>
                            </div>
                        )}
                    </li>
                )}
                {trailingItems.map((item: SubMenuItem) => {
                    return (!item.groupped) ? (
                        <li
                            key={item.menuItem}
                            className={cx(
                                styles.DesktopHeader__subMenuItem,
                                item.className,
                                activeItem === item.menuItem && styles['DesktopHeader__subMenuItem--active'],
                                activeItem === item.menuItem && 'topmenu-activeLink',
                            )}
                        >
                            {item.content}
                        </li>
                    ) : null;
                })}
            </ul>
        );
    }

    private renderHeartsWallSettingsStripe(activeSection: string, activeItem: string) {
        const {
            heartsCount, unreadMails, wallStatusNews, requestUser, onMenuClose,
            notificationMenuRef, onStoreEvent, currentUrl,
        } = this.props;

        return (requestUser && isAuthenticated(requestUser)) ? (
            <NotificationMenu
                ref={notificationMenuRef}
                heartsCount={heartsCount}
                unreadMails={unreadMails}
                wallStatusNews={wallStatusNews}
                requestUser={requestUser}
                activeSection={activeSection}
                activeItem={activeItem}
                onItemClick={onMenuClose}
                onStoreEvent={onStoreEvent}
            />
        ) : (
            <div className={styles.DesktopHeader__user}>
                <Link
                    className={styles['DesktopHeader__user--loginLink']}
                    to={url(loginUrl, {}, { next: currentUrl })}
                    rel="nofollow"
                >
                    <Interpolate i18nKey={LOG_IN} />
                </Link>
                <Link
                    className={cx(styles['DesktopHeader__user--registerLink'], 'topmenu-registerLink')}
                    to={url(signupUrl, {}, { mkutm_campaign: 'menu_registration', mkutm_source: 'modrykonik', next: currentUrl })}
                    rel="nofollow"
                >
                    {REGISTER_HERE}
                </Link>
            </div>
        );
    }

    private setSubMenuDropdownRef = (element) => {
        this.subMenuDropdownRef = element;
    };

    private onClickOutside = () => {
        if (this.props.subMenuDropdownOpened) {
            this.props.onSubMenuDropdownChange(false);
        }
    };

    private handleToggleSubMenuDropdown = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        event.stopPropagation();
        const { subMenuDropdownOpened, onSubMenuDropdownChange } = this.props;
        onSubMenuDropdownChange(!subMenuDropdownOpened);
    };
}
